<template>
<div class="chapter">
<div class="inner_page">
<div class="story">
<p class="parttitle">PART ONE</p>
<p class="parttitle">The Paleo Way</p>
<p class="epigraph"><em class="italic">If man made it, don’t eat it.</em></p>
<p class="epigraphsource">—Jack LaLanne</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?30be7dba